import React from 'react'
import MobileEmptyStateCard from '../../../components/MobileEmptyStateCard'
import { formatMoney } from '../../../helpers/utils'
import { getRefundRowSubtotal, getRefundWeight } from '../shared/refundDetailsHelpers'

const RefundDetailsLineCard = ({ product, extraColumns }) => {
  const staticRows = [
    ['Código', product.product_db_ref || '-'],
    ['N° lote', product.batch_number || 'N/A'],
    ['Motivo', product.motive || 'N/A'],
    ['Peso neto', getRefundWeight(product.weight)],
    ['Unidad de venta', product.price_unit || '-'],
    ['Cantidad', Number(product.quantity || 0).toFixed(2)],
    ['Precio', formatMoney(Number(product.unit_price || 0))],
    ['Sub-total', formatMoney(getRefundRowSubtotal(product.extended_price, product.discount_price))]
  ]

  return (
    <div className="order-detail-line-card">
      <div className="order-detail-line-product-name">{product.product_name}</div>
      {staticRows.map(([label, value]) => (
        <div key={label} className="order-detail-line-row">
          <span className="order-detail-line-label">{label}</span>
          <span className="order-detail-line-value">{value}</span>
        </div>
      ))}
      {extraColumns.map((field) => (
        <div key={field} className="order-detail-line-row">
          <span className="order-detail-line-label">{field}</span>
          <span className="order-detail-line-value column-custom">
            {product.customFieldValues?.[field] || 'N/A'}
          </span>
        </div>
      ))}
    </div>
  )
}

export default function RefundDetailsMobileLines({ processedDetails, extraColumns }) {
  if (!processedDetails?.length) {
    return (
      <MobileEmptyStateCard
        title="No hay productos"
        description="Cuando esta devolución tenga productos asociados, aparecerán aquí."
      />
    )
  }

  return (
    <div className="order-detail-line-items-mobile">
      {processedDetails.map((product, index) => (
        <RefundDetailsLineCard key={index} product={product} extraColumns={extraColumns} />
      ))}
    </div>
  )
}
